module.exports = __webpack_public_path__ + "img/logo-cropped.054b307a.png";